/**
 * "Lichidare de stoc" campaign (29 iulie - 31 august 2026).
 * Drives the dashboard header banner and the StockLiquidationPopup.
 * Outside this window both fall back to / disappear automatically.
 */
export const STOCK_LIQUIDATION_START = new Date("2026-07-29T00:00:00")
export const STOCK_LIQUIDATION_END = new Date("2026-08-31T23:59:59")

// Category #27610 = LICHIDARE DE STOC (#27616 is the BLACK FRIDAY category)
export const STOCK_LIQUIDATION_URL =
  '/shop/productlist?filters=%7B"FLT-CATEG001"%3A%5B"%2327610"%5D%7D&page=1&sortBy=ranking'

export const isStockLiquidationActive = () => {
  const now = new Date()
  return now >= STOCK_LIQUIDATION_START && now <= STOCK_LIQUIDATION_END
}
